import React from 'react';
import {Link} from 'react-router-dom';
import logoHeader from '../../img/logo/Logo_white.png';



const Header_m =() => {
    return <div>
        {/* Menu for the large version */}

        <nav className=" brown darken-4 nav-extended  hide-on-small-only">
            <div className="nav-wrapper">
                {/* Imnage for Logo */}
                <img class="container-logo center-align responsive-img" src={logoHeader}></img>

            </div>

            <div className="nav-content">
                <ul className="tabs tabs-transparent">
                    <li className="tab"><Link  class='white-text large-progress-menu-text' to ='/Home'>Home</Link></li>
                    <li className="tab"><Link class='white-text large-progress-menu-text' to ='/Concrete'>Concrete</Link></li>
                    <li className="tab"><Link class='white-text large-progress-menu-text' to ='/Stone'>Stone Work</Link></li>
                    <li className="tab"><Link class='white-text large-progress-menu-text' to ='/Remodel'>Remodel</Link></li>
                    <li className="tab"><Link class='white-text large-progress-menu-text' to ='/About'>About</Link></li>
                    <li className="tab"><Link class='white-text large-progress-menu-text' to ='/Contact'>Contact</Link></li>
                {/* Right hand Menu
                Contractor license number */}
                    <li className="tab right"><Link  class='white-text large-progress-menu-text' to ='/Home'>Lincence: G67-03000</Link></li>
                </ul>
            </div>
        </nav>


        {/* Menu for Mobile Version  */}
        <div class="hide-on-med-and-up">

    
            <ul class="collection  brown darken-4">
            <div className="nav-wrapper">
                {/* Imnage for Logo */}
                <img class="container-logo center-align responsive-img" src={logoHeader}></img>

            </div>
                <li class="collection-header"><h1 class="white-text ">Progress Concrete</h1></li>

                <li class="collection-item"><Link class='brown-text bold' to ='/Home'>Home</Link></li>
                <li class="collection-item"><Link class='brown-text' to ='/Concrete'>Concrete</Link></li>
                <li class="collection-item"><Link class='brown-text' to ='/Stone'>Stone Work</Link></li>
                <li class="collection-item"><Link class='brown-text' to ='/Remodel'>Remodel</Link></li>
                <li class="collection-item"><Link class='brown-text' to ='/About'>About</Link></li>
                <li class="collection-item"><Link class='brown-text' to ='/Contact'>Contact</Link></li>
            </ul>
        </div>
    </div>

}
export default Header_m;